import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'dr/20161228_155652.jpg' satisfies MediaPath
const a = 'dr/20161229_143010.jpg' satisfies MediaPath
// TODO: replace placeholder images with real 2022 photos

export const meta: EntryMeta = {
	slug: '2022',
	name: '2022',
	excerpt: 'Selected frames',
	tags: ['photography'],
	cover,
	order: 140,
}

export default function Year2022() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2022' },
					{ src: a, alt: '2022' },
				]}
			/>
		</>
	)
}
